export default "__VITE_ASSET__DAiRakvL__"